export default __webpack_public_path__ + "static/svg-sprite-14b1454b02b4617e1e51da188e12e045.svg";